export default "__VITE_ASSET__DPTEB50b__"